import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import ThemeProvider from "./theme";
import {ThemeSettings} from "./components/settings";
import {SnackbarProvider} from "notistack";
import {LoadingProvider} from "./context/Loading";
import Scrollbar from "./components/Scrollbar";
import Router from "./routes";
import TimerProvider from "./context/TimerContext";
import ScrollToTop from "./components/ScrollToTop";

function App() {
    return (
        <MotionLazyContainer>
            <ThemeProvider>
                <ThemeSettings>
                    <SnackbarProvider>
                        <LoadingProvider>
                            <TimerProvider>
                                <Scrollbar sx={{maxHeight: "100vh"}}>
                                    <ScrollToTop/>
                                    <Router/>
                                </Scrollbar>
                            </TimerProvider>
                        </LoadingProvider>
                    </SnackbarProvider>
                </ThemeSettings>
            </ThemeProvider>
        </MotionLazyContainer>
    );
}

export default App;
